module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-logo-rddm.bb949a6.jpg";